package com.essntl.features.currency.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.currency.data")
class CurrencyModule
